import type { FaireProductEntity } from "../../entity_types/product";

export const p_wpc83d8ss5: FaireProductEntity = {
  token: "p_wpc83d8ss5",
  type: "product",
  name: "Dream Aromatherapy Spray",
  brandToken: "b_pt47qddvxc",
  brandName: "Mindful and Co Kids USA",
  imageUrl:
    "https://cdn.faire.com/fastly/9b5e75b51e549ea62fd3af94a3de80b10d7cd5d9b2d8ff0c5c039c6d5c82c382.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b9aecbde9cac4ce5220567f0a9a64c9edc624a9ab9ed5c50f406d944b6865de3.png",
    "https://cdn.faire.com/fastly/9782e445957b8744fc66edb683b7e5c65dfe2064d1fa0cbe7fd070ed7cac736a.png",
    "https://cdn.faire.com/fastly/b8fd8211276fa668fa67403bcb2488da21b429cc61f0cb96e0de4139dc8088fe.png",
    "https://cdn.faire.com/fastly/3e14b8cdc16b54fb483c2771901ede7c050b41c1b5e3c64e651ff5ec352f9311.png",
  ],
  priceDollars: 10,
  description:
    "Discover Dream Aromatherapy Mist - your child's sleep companion, thoughtfully designed and made in Australia.\n\nQuality sleep is vital for babies, kids, and teenagers. Our mist induces a natural slumber with gentle, warming notes of witch hazel, vetiver, lavender, and Roman chamomile, creating a peaceful bedtime routine.\n\nPrioritize your child's well-being with this essential mist, perfect for baby gifts and promoting restful nights. Embrace bedtime tranquility, support their growth, and ensure they wake up refreshed and ready for new adventures!\n\nFeatures:\n\nPromotes restorative sleep\nAids physical healing\nEncourages creative brain development\nGentle and calming scent\nSuitable for babies, children, and teenagers\nDesigned in Australia.",
  tags: [],
  msrpDollars: 20,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:55:04.044Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
